import * as yup from 'yup';

export const CoordinatesSchema = yup.object({
  x: yup.number().positive().notRequired(),
  y: yup.number().positive().notRequired(),
});
export type ICoordinates = yup.InferType<typeof CoordinatesSchema>;
